import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { UserService } from '../UserService';
import { useSelector } from 'react-redux';
import { Client } from "@hiveio/dhive";
import { css } from "@emotion/react";
import PacmanLoader from "react-spinners/PacmanLoader";
import { onHandleNFTBulkBuyAction, onHandleNFTBuyAction } from "./../utils/actions/nftMarketBuy"
import { onHandleNFTCancelAction, onHandleBulkNFTCancelAction } from "./../utils/actions/nftMarketCancel"
import NftCard from '../components/NftCard';
import { symbolNft, symbolPack } from '../config/config';
import { Button, Modal, Tab, Tabs } from 'react-bootstrap';
import ConfirmModal from '../components/ConfirmModal';
import { AnonAdCorner } from '../components/Ads';
import './Marketplace.scss';
import { extractCategories, parseSchemaName } from '../utils/inventory/utils';


const hiveClient = new Client('https://anyx.io');

const override = css`
display: block;
margin: 30px auto;
border-color: red;
`;


export const Marketplace = () => {
    // const apiEndpoint = process.env.REACT_APP_API_URL;
    const UserState = useSelector((store) => store.user);
    const [nftList, setNftList] = useState([]);
    const [searchOwner, setSearchOwner] = useState('');
    const [searchNftName, setSearchNftName] = useState('');

    const [loading, setLoading] = useState(true);
    const [selectedOwnNft, setSelectedOwnNft] = useState([]);
    const [selectedNft, setSelectedNft] = useState([]);
    const [confirmShow, setConfirmShow] = useState(false);
    const [type, setType] = useState('');
    const [currentNftSymbol, setCurrentNftSymbol] = useState(symbolPack);
    const [offset, setOffset] = useState(0);

    const keychain = window.hive_keychain;

    const isLocal = process.env.REACT_APP_ENV_MODE !== 'production';
    const fetchUrl = isLocal ? 'https://enginetestnet.rishipanthee.com/contracts' : 'https://engine.rishipanthee.com/contracts';

    const handleConfirmClose = () => setConfirmShow(false);

    const toggleSingleAndPacks = (type) => {
        setLoading(true);
        switch (type) {
            case 'pack': {
              setCurrentNftSymbol(symbolPack);
              setNftList([]);
              setOffset(0);
              break;
            }
            case 'single': {
              setCurrentNftSymbol(symbolNft);
              setNftList([]);
              setOffset(0);
              break;
            }
            default: { console.error('Unexpected type in NFT toggle:', type); }
        }
    };

    const fetchNftList = async () => {
        setLoading(true);
        try {
            let res = await axios.post(fetchUrl, [{
                method: "find",
                jsonrpc: "2.0",
                params: {
                    contract: "nftmarket",
                    table: `${currentNftSymbol}sellBook`,
                    query: {},
                    limit: 1000,
                    offset: offset,
                    indexes: []
                },
                id: 1
            }]);
            let marketNFT = res.data[0]?.result ?? [];

            let resAll = await axios.post(fetchUrl, [{
                method: "find",
                jsonrpc: "2.0",
                params: {
                    contract: "nft",
                    table: `${currentNftSymbol}instances`,
                    query: { account: "nftmarket" },
                    limit: 1000,
                    offset: offset,
                    indexes: []
                },
                id: 1
            }]);
            let allNftList = resAll.data[0]?.result ?? [];

            marketNFT = marketNFT.map(mNft => {
                let nft = allNftList.filter(_nft => _nft._id === Number(mNft.nftId))[0];
                if (!nft) return null; // @@
                return ({
                    ...mNft,
                    properties: nft.properties
                })
            }).filter(el => !!el);
            setLoading(false);
            console.log('marketNFT', currentNftSymbol, marketNFT);
            return marketNFT;
        } catch (err) {
            console.log('Caught error fetching NFT list:', err);
            setLoading(false);
            return [];
        }

    }

    useEffect(() => {
        (async function fetchData() {
            console.log("page loaded or NFT type changed (single vs pack)");
            // if (nftList.length) return;
            let data = await hiveClient.database.getAccounts([UserState.username]);
            console.log('hive user data:', UserState.username, data);

            let marketNFT = await fetchNftList();
            console.log(marketNFT);
            setNftList(marketNFT);
        })();
    }, [currentNftSymbol, offset]);

    // useEffect(() => {
    // }, [selectedOwnNft])

    const handleOwnCheck = (id, checked) => {
        let selected = selectedOwnNft;
        selected = selected.filter(sel => sel !== id);
        if(checked) {
            selected.push(id);
        }
        setSelectedOwnNft(selected);
    }

    const handleCheck = (id, checked) => {
        let selected = selectedNft;
        selected = selected.filter(sel => sel !== id);
        if(checked) {
            selected.push(id);
        }
        setSelectedNft(selected);
    }

    const handleConfirm = async () => {
        if(type === "buy") {
            console.log('selectedNft', selectedNft);
            await onHandleNFTBulkBuyAction(keychain, selectedNft, UserState.username, currentNftSymbol);
        } else {
            console.log('selectedOwnNft', selectedOwnNft);
            await onHandleBulkNFTCancelAction(keychain, selectedOwnNft, UserState.username, currentNftSymbol);
        }
        setConfirmShow(false);
    }

    const isPacksView = currentNftSymbol === symbolPack;
    const isSingNftsView = currentNftSymbol === symbolNft;

    return (
        <div className="container marketplace">
            <div className="row mt-4">
                <div id="header-wrap" className="">
                    <div id="conversions" className="">
                        <p className="text-white convert-crypto">
                          <a href="https://swaphive.github.io/swap/" target="_blank" rel="noreferrer" style={{ textDecoration: 'underline' }}>
                            SWAP HIVE
                          </a> FOR SWAP.HIVE
                          <p id="soon-buy-hive">(soon we'll support purchases directly in Hive)</p>
                        </p>
                        <p className="text-white convert-crypto" style={{ marginBottom: '0px' }}>
                          <a href="https://peakd.com/hive-185582/@bacon-dub/welcome-cryptoshot-players-to-hive" target="_blank" rel="noreferrer" style={{ textDecoration: 'underline' }}>
                            SWAP WAX
                          </a> FOR SWAP.HIVE
                        </p>
                    </div>
                </div>

                <div id="nft-type-choice" className="col-12 row">
                  <div className="col-1">
                      <span className='text-white' style={{ fontSize: '32px', fontWeight: 'bolder' }}>TRADE</span>
                  </div>
                  <div className="col-4">
                    <button
                        style={{ marginRight: '10px', marginLeft: '40px', color: isPacksView ? 'black' : 'white' }}
                        className={`nft-type-choice-btn${isPacksView ? ' disabled' : ''}`}
                        onClick={() => toggleSingleAndPacks('pack')}
                        disabled={isPacksView}
                      >
                        PACKs
                      </button>
                    <button
                        style={{ marginRight: '5px', color: isSingNftsView ? 'black' : 'white' }}
                        className={`nft-type-choice-btn${isSingNftsView ? ' disabled' : ''}`}
                        onClick={() => toggleSingleAndPacks('single')}
                        disabled={isSingNftsView}
                    >
                        ITEMS
                    </button>
                  </div>

                  <div id="search-field" className="col-1"></div>
                  <div id="search-field" className="col-3" style={{ marginTop: '-35px' }}>
                      <input className='form-control' placeholder='Search by Owner...' value={searchOwner} onChange={(e) => setSearchOwner(e.target.value)} />
                      <input className='form-control' placeholder='Search by NFT name...' value={searchNftName} onChange={(e) => setSearchNftName(e.target.value)} style={{ marginTop: '5px' }} />
                    </div>
                </div>

                <div className="col-12" id="market-pagination">
                  {(nftList.length >= 1000 || offset >= 1000) && <div className="text-white">
                    <button
                      onClick={() => setOffset(0)}
                      disabled={offset === 0}>
                        Page 1
                    </button>
                    <button
                    onClick={() => setOffset(1000)}
                    disabled={offset === 1000}
                    >
                        Page 2
                    </button>
                    <button
                    onClick={() => setOffset(2000)}
                    disabled={offset === 0 || offset === 2000 || nftList.length < 1000}>
                        Page 3
                    </button>
                    <button
                    onClick={() => setOffset(3000)}
                    disabled={offset === 0 || offset === 3000 || nftList.length < 1000}>
                        Page 4
                    </button>
                    </div>}
                </div>

                <div id="tab-wrapper" className="col-12">
                    {loading && <div className="col-12 mt-5 pt-5">
                    <PacmanLoader color={"#fff"} loading={loading} css={override} size={30} margin={2} />
                    </div>}
                    {(!loading && !nftList.length) && <h5 className='no-nfts'>You do not have Crypto Shots NFT listed for sale.</h5>}
                    {!loading && <Tabs defaultActiveKey="others" id="uncontrolled-tab-example" className="mb-3">
                        <Tab eventKey="owns" title="Your NFTs on the Market">

                          {nftList.filter(nft => nft.account === UserState.username).length > 0
                            ? <div className="row">
                                <div className="col-12">
                                  <div id="bulk-canc-btn-wrap" className="text-right bulk-btn-wrap">
                                    <Button
                                      variant='danger'
                                      disabled={selectedOwnNft.length === 0}
                                      onClick={() => {
                                        setConfirmShow(true);
                                        setType('cancel');
                                      }}
                                    >
                                      Bulk Cancel
                                    </Button>
                                    {/* onHandleBulkNFTCancelAction(keychain, selectedOwnNft, UserService.username, currentNftSymbol) */}
                                  </div>
                                  </div>
                                  <YourFilteredNFtsMarket
                                    nftList={nftList}
                                    searches={{ searchOwner, searchNftName }}
                                    actions={{ onHandleNFTCancelAction, handleOwnCheck }}
                                    otherState={{ currentNftSymbol, selectedOwnNft }}
                                  />
                                </div>
                              : <h5 className="no-nfts">None</h5>
                            }
                        </Tab>&nbsp; &nbsp; &nbsp;
                        <Tab eventKey="others" title="Buy NFTs from the Market">
                            <div id="bulk-canc-btn-wrap" className="text-right bulk-btn-wrap" style={{ marginTop: '-25px' }}>
                                <Button
                                  variant='primary'
                                  disabled={selectedNft.length === 0}
                                  onClick={() => {
                                    setConfirmShow(true);
                                    setType('buy');
                                  }}>
                                    Bulk Buy
                                  </Button>
                            </div>
                            <div className="row">
                              <AllFilteredNFTsMarket
                                nftList={nftList}
                                searches={{ searchOwner, searchNftName }}
                                actions={{ onHandleNFTBuyAction, handleCheck }}
                                otherState={{ currentNftSymbol, selectedNft }}
                              />
                            </div>
                        </Tab>
                    </Tabs>}
                </div>
                <ConfirmModal show={confirmShow} handleHide={handleConfirmClose} handleConfirm={handleConfirm} />
            </div>

            <AnonAdCorner />
        </div>
    );
};

const AllFilteredNFTsMarket = ({ nftList = [], searches, actions, otherState }) => {
  const { searchOwner, searchNftName } = searches;
  const { onHandleNFTBuyAction, handleCheck } = actions;
  const { currentNftSymbol, selectedNft } = otherState;
  const UserState = useSelector((store) => store.user);

  const [collapsed, setCollapsed] = useState([]);

  const handleCollapse = (category) => {
    if (!collapsed.includes(category)) setCollapsed([...collapsed, category]);
    else setCollapsed([...collapsed.filter(cat => cat !== category)]);
  };

  if (!nftList.length) return (<h5 className="no-nfts">None</h5>);

  const foundCategories = extractCategories({ hiveNfts: nftList });
  const filteredList = nftList.filter(
    nft => nft.account !== UserState.username
      && nft.account.toLowerCase().includes(searchOwner.toLowerCase())
      && nft.properties.name && nft.properties.name.toLowerCase().includes(searchNftName.toLowerCase().replace('@', ''))
  );

  const PageElements = ({ categoryItems }) => <p>
    {categoryItems
      .sort((aa, bb) => parseFloat(aa.price) - parseFloat(bb.price))
      .map((nft, index) =>
        <div className="col-3 align-left categorized-items" key={index}>
            <NftCard
              nft={nft}
              action={() => onHandleNFTBuyAction(window.hive_keychain, nft, UserService.username, currentNftSymbol)}
              actionType="Buy"
              checked={selectedNft.findIndex(sel => sel === nft.nftId) >= 0}
              handleCheck={handleCheck}
            />
        </div>
      )}
  </p>;

  const CategorizedItems = ({ category }) => {
    const categoryItems = filteredList.filter(({ properties }) => properties.schema === category);
    return (
      <>
        <div className="category-name col-12 row" style={{ paddingLeft: '30px' }} onClick={() => handleCollapse(category)}>
        <div className="col-3">
            {parseSchemaName(category)}
          </div>
          <div className="col-8 category-count">[ {categoryItems.length} items ]</div>
          <div className="col-1">
            <img
              className={!collapsed.includes(category) ? 'flipped' : ''}
              src="https://cdn3.iconfinder.com/data/icons/neutro-interface/32/previous-64.png"
              width="20" alt="collapse"
            />
          </div>
        </div>
        {collapsed.includes(category)
          ? <></>
          : <PageElements {...{ categoryItems }} />
        }
      </>
    );
  };

  return (
    <>
      {foundCategories.map(category => <CategorizedItems category={category} />)}
    </>
  );
};


const YourFilteredNFtsMarket = ({ nftList = [], searches, actions, otherState }) => {
  const { searchOwner, searchNftName } = searches;
  const { onHandleNFTCancelAction, handleOwnCheck } = actions;
  const { currentNftSymbol, selectedOwnNft } = otherState;
  const UserState = useSelector((store) => store.user);

  const [collapsed, setCollapsed] = useState([]);

  const handleCollapse = (category) => {
    if (!collapsed.includes(category)) setCollapsed([...collapsed, category]);
    else setCollapsed([...collapsed.filter(cat => cat !== category)]);
  };

  const foundCategories = extractCategories({ hiveNfts: nftList });
  const filteredList = nftList.filter(
    nft => nft.account === UserState.username
      // && nft.account.toLowerCase().includes(searchOwner.toLowerCase())
      &&  nft.properties.name && nft.properties.name.toLowerCase().includes(searchNftName.toLowerCase().replace('@', ''))
  );

  const PageElements = ({ categoryItems }) => <p>
    {categoryItems
      .sort((aa, bb) => parseFloat(aa.properties?.price) - parseFloat(bb.properties?.price))
      .map((nft, index) =>
        <div className="col-3 align-left categorized-items" key={index}>
          <NftCard
            nft={nft}
            action={() => onHandleNFTCancelAction(window.hive_keychain, nft, UserService.username, currentNftSymbol)}
            actionType="Buy"
            ownNFT
            checked={selectedOwnNft.findIndex(sel => sel === nft.nftId) >= 0}
            handleCheck={handleOwnCheck}
          />
        </div>
      )
    }
  </p>;

  const CategorizedItems = ({ category }) => {
    const categoryItems = filteredList.filter(({ properties }) => properties.schema === category);
    return (
      <>
        <div className="category-name col-12 row" style={{ paddingLeft: '30px' }} onClick={() => handleCollapse(category)}>
          <div className="col-3">
            {parseSchemaName(category)}
          </div>
          <div className="col-8 category-count">[ {categoryItems.length} items ]</div>
          <div className="col-1">
            <img
              className={!collapsed.includes(category) ? 'flipped' : ''}
              src="https://cdn3.iconfinder.com/data/icons/neutro-interface/32/previous-64.png"
              width="20" alt="collapse"
            />
          </div>
        </div>
        {collapsed.includes(category)
          ? <></>
          : <PageElements {...{ categoryItems }} />
        }
      </>
    );
  };
    
  return (
    <>
      {foundCategories.map(category => <CategorizedItems category={category} />)}
    </>
  );
};
